import { ProductPriceListConversion } from './product-price-list-conversion';

export interface ProductDetails {
  id: string;
  key: string;
  oldCode: string;
  description: string;
  shortDescription: string;
  productTypeId: string;
  productTypeDescription: string;
  productionProcessId: string;
  minimumStockLevel: number;
  stdPrice: number;
  stdCutPrice: number;
  stdCutCostPrice: number;
  customerId: string;
  customerKey: string;
  customerName: string;
  productGroupId: string;
  priceGroupId: string;
  unitOfMeasureId: string;
  dateCreated: Date;
  createdBy: string;
  lastUpdatedDate: Date;
  lastUpdatedBy: string;
  salesNominalCodeId: string;
  purchaseNominalCodeId: string;
  comments: string;
  obsolete: boolean;
  boughtIn: boolean;
  imagePath: string;
  imagePath2: string;
  standardCostValue: number;
  standardCostConversion: number;
  priceListConversionUnitId: string;
  warehouseToAllocate: boolean;
  certificateOfConformityRequired: boolean;
  labTestsRequired: boolean;
  testReportRequired: boolean;
  categoryId: string;
  allowProductTypeAmend: boolean;
  clearanceProduct: boolean;
  commodityCode: string;
  hsCode: string;
  leadTime: number;
  unitOfMeasure: string;
  baseCurrency: string;
  calculatedStdCost: number;
  importDuty: number;
  freightCost: number;
  orderUnitOfMeasureId: string;
  attachSpecPrintToPurchaseOrder: boolean;
  notes: string;
  cutPrice: boolean;
  ignoreOnStockForecasting: boolean;
  minimumStockItemQuantity: number;
  allowProcessing: boolean;
  returnableProduct: boolean;
  originId: string;
  originKey: string;
  originDescription: string;

  priceListConversions: ProductPriceListConversion[];
}
